import React from 'react';
import PropTypes from 'prop-types';
import {CSSTransition} from 'react-transition-group';

import './index.scss';

const SlideUp = ({isComponentIn, children, classname}) => (
  <CSSTransition in={isComponentIn} timeout={500} unmountOnExit classNames={classname}>
    {children}
  </CSSTransition>
);

SlideUp.propTypes = {
  isComponentIn: PropTypes.bool,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  classname: PropTypes.string,
  children: PropTypes.node,
};

export default SlideUp;
